import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  standalone: false,
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  isAdmin$: Observable<boolean>;
  isUser$: Observable<boolean>;
  isMenuHidden = true;

  constructor(private authService: AuthService, private router: Router) {
    this.isAdmin$ = this.authService.isAdmin;
    this.isUser$ = this.authService.isUser;
  }

  get isUserOrAdmin$() {
    return combineLatest(
      [this.isUser$, this.isAdmin$],
      (isUser, isAdmin) => isUser || isAdmin
    );
  }

  toggleMenu() {
    this.isMenuHidden = !this.isMenuHidden;
  }

  onLogout() {
    this.authService.logout();
    this.router.navigate(['/']);
  }
}
